import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'lns-form-field-error',
  templateUrl: './form-field-error.component.html',
  styleUrls: ['./form-field-error.component.scss']
})
export class FormFieldErrorComponent {
  @Input() formGroup: FormGroup | undefined;
  @Input() translatePfx: string | undefined;
  @Input() field: string | undefined;
}
